export default __webpack_public_path__ + "static/media/rappi.5bdf1e99.png";